import { Box, Stack, styled, useTheme } from '@mui/material';
import { CloseIcon, HamburgerIcon } from '@synergy/theme-next';
import { FilterParams } from '@synergy/models';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import { PoolIconButton, PoolTypography } from '@synergy/components-next';
import { ReactElement, useRef, useState } from 'react';
import { useNavigate } from 'react-router';

import { CategoryTreeMenu } from './menu/category-tree-menu';
import { ROUTES } from '../../../utils/routes';
import { headerSelector } from '../../../store/configuration-selectors';
import { useAppSelector } from '../../../../store/store';

const Wrapper = styled(Stack)(({ theme }) => ({
    justifyContent: 'center',
    width: 188,
    color: theme.palette.common.white,

    '&:hover': {
        cursor: 'pointer',
        color: theme.palette.grey[700],
    },
}));

export const CategoryTreeView = (): ReactElement => {
    const theme = useTheme();
    const anchorRef = useRef(null);
    const [isOpen, setIsOpen] = useState(false);
    const header = useAppSelector(headerSelector);
    const navigate = useNavigate();

    const handleSelect = (categoryId: number): void => {
        setIsOpen(false);
        navigate({
            pathname: ROUTES.searchPage,
            search: new URLSearchParams({ [FilterParams.CategoryId]: categoryId.toString() }).toString(),
        });
    };

    return (
        <Wrapper onClick={() => setIsOpen(true)}>
            <Stack direction="row" alignItems="center" ml={-1} height={24}>
                <Box ref={anchorRef}>
                    <PoolIconButton size="medium" color="inherit">
                        {!isOpen ? <HamburgerIcon /> : <CloseIcon sx={{ color: theme.palette.primary.main }} />}
                    </PoolIconButton>
                </Box>
                <CategoryTreeMenu
                    isOpen={isOpen}
                    anchorEl={anchorRef.current}
                    onClose={() => setIsOpen(false)}
                    onSelect={handleSelect}
                />

                <PoolTypography translationId="app.topNavigation.allArticles" variant="subtitle1" />
            </Stack>
            <PoolTypography variant="body2">
                <FormattedMessage
                    id="app.header.activeProductCount"
                    values={{ value: <FormattedNumber value={header.activeProductCount} notation="compact" /> }}
                />
            </PoolTypography>
        </Wrapper>
    );
};
